// extracted by mini-css-extract-plugin
export default {"themeSwitcher":"theme-switcher_themeSwitcher__BAe-D","light":"theme-switcher_light__BPboW","switcherCircle":"theme-switcher_switcherCircle__u3Z7-"};